import React from "react";
import { Link } from "react-router-dom";
import ImagesSection from "./ProjCompImg";


const ProjectCompletedSectionTwo = () => {

  return (
    <div className="flex flex-col md:flex-row bg-[#0c2341] text-white">
      <main className="">
        <h1 className="text-base md:text-2xl md:mb-3 py-2">
          <Link to="/">Home</Link> / AKT STEEL /{" "}
          <span className="font-bold">AKT SHOWROOM & WORKSHOPS PROJECTS /</span>
          <span className="font-bold">PROJECTS COMPLETED</span>
        </h1>
        <h1 className="text-2xl md:text-4xl font-bold">
        PROJECT IMAGES
        </h1>
        <div className="">
          <ImagesSection />
        </div>
      </main>
    </div>
  );
};

export default ProjectCompletedSectionTwo;
